import React, { useContext } from "react";
import { PermissionContext } from "../../../contexts/PermissionContext";
import { IDispatchActionsFormSection } from "../../../interfaces";
import { Role } from "../../../utils";
import { UnknownStatus } from "../../Shared/UnknownStatus";
import { ApprovalActions } from "./ApprovalActions";
import { ApprovedActions } from "./ApprovedActions";
import { DispatchedActions } from "./DispatchedActions";
import { DispatchReadyActions } from "./DispatchReadyActions";
import { DraftActions } from "./DraftActions";
import { RejectedActions } from "./RejectedActions";

export const DispatchActions: React.FC<IDispatchActionsFormSection> = ({
    status,
    formValid,
    onSubmit,
    onDelete,
    onApprove,
    onReady,
    onDispatched,
    onReject,
    onClose,
    onComplete,
    collectedBy,
    setCollectedBy,
    readonly,
    approvers,
    commercialApprovedDate,
    platformEngineerApprovedDate,
    ...props
}: IDispatchActionsFormSection) => {

    const permissionContext = useContext(PermissionContext);

    console.log("approvers", approvers, permissionContext.userId, commercialApprovedDate, platformEngineerApprovedDate);

    let approvalAllowed = false;

    if (approvers[0] === permissionContext.userId && commercialApprovedDate === undefined)
        approvalAllowed = true;

    if (approvers[1] === permissionContext.userId && platformEngineerApprovedDate === undefined)
        approvalAllowed = true

    return (
        <div>
            {{
                0: UnknownStatus(),
                1: DraftActions(onDelete, formValid ? onSubmit : undefined),
                2: ApprovalActions(permissionContext.isRole(Role.Internal.AssetProtection), formValid, "Asset Protection", onApprove, onReject),
                3: ApprovalActions(approvalAllowed, formValid, "Commercial", onApprove, onReject, approvers, commercialApprovedDate, platformEngineerApprovedDate),
                4: ApprovedActions(permissionContext.isRole(Role.Internal.AssetProtection) ? onReady : undefined, onClose),
                5: DispatchReadyActions(permissionContext.isRole(Role.Internal.AssetProtection), onDispatched, onClose, collectedBy, setCollectedBy),
                6: DispatchedActions(collectedBy),
                7: RejectedActions(formValid ? onSubmit : undefined, onClose),
                8: <></>,
            }[status]}
        </div>
    );

}